import React from 'react';
import { useMemo } from 'react';
import { DateUtils } from '../../utils/date.utils';

export type DateViewProps = {
    value: Date | string | null | undefined;
    format?: DateUtils.FormatOptions;
};

export function DateView({ value, format }: DateViewProps) {
    const formatted = useMemo(() => DateUtils.format(value, format), [value]);

    return <span className="app-date-view">{formatted}</span>;
}
